import { ReactNode, useEffect } from 'react';
import { cn } from '@/lib/utils/cn';

const APP_TITLE_SUFFIX = 'Snapes Quoting Tools 2.0';

export function useDocumentTitle(title?: string) {
  useEffect(() => {
    document.title = title ? `${title} | ${APP_TITLE_SUFFIX}` : APP_TITLE_SUFFIX;
  }, [title]);
}

interface PageHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  breadcrumb?: ReactNode;
  className?: string;
  titleClassName?: string;
  descriptionClassName?: string;
}

export function PageHeader({
  title,
  description,
  actions,
  breadcrumb,
  className,
  titleClassName,
  descriptionClassName,
}: PageHeaderProps) {
  useDocumentTitle(typeof title === 'string' ? title : undefined);

  return (
    <div className={cn('flex flex-wrap items-end justify-between gap-4', className)}>
      <div className="flex flex-col gap-1">
        {breadcrumb}
        <h2
          className={cn(
            'text-3xl font-black tracking-tight text-gray-900 dark:text-white',
            titleClassName,
          )}
        >
          {title}
        </h2>
        {description && (
          <p
            className={cn(
              'text-sm font-medium text-primary dark:text-gray-400',
              descriptionClassName,
            )}
          >
            {description}
          </p>
        )}
      </div>
      {actions && <div className="flex flex-wrap gap-3">{actions}</div>}
    </div>
  );
}
